// extracted by mini-css-extract-plugin
module.exports = {"payments":"FooterPayments_payments__60Ju_","iyzico":"FooterPayments_iyzico__CL3i_"};